import * as React from 'react';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import moment from 'moment';

import { toggleCallNotes } from '@/redux/app/actions/event';
import type { EventElementProps } from '../event-element-props.interface';
import { AddNotesToCall } from './AddNotesToCall';

export interface CallProps extends EventElementProps {
  ticket: string;
  eventId: string;
}

export const Call = ({ data, ticket, eventId }: CallProps) => {
  let callStatus: string;
  if (data.dial_call_status === 'no-answer') {
    callStatus = 'No one picked up.';
  } else if (data.dial_call_status === 'busy') {
    callStatus = 'Line was Busy.';
  } else if (data.call_status === 'cancelled') {
    callStatus = 'Caller hung up.';
  } else {
    callStatus = data.distance_of_time_in_words;
  }

  const dispatch = useDispatch();
  const toggleOpenNotes = useCallback(() => {
    dispatch(toggleCallNotes(ticket, eventId));
  }, [eventId, ticket, dispatch]);

  return (
    <div id={`Call-${data.id}`} className={`call-box ${data.direction}`}>
      <div className="container">
        <div className="content">
          <div className="calling">
            <div>
              <div className={`${data.direction}-call`}>
                {data.sender_tag}
              </div>
              {data.duration > 0 && (
                <div className="chat-duration">
                  {callStatus}
                </div>
              )}
              <div className="audio">
                {data.voicemail && (
                  // eslint-disable-next-line jsx-a11y/media-has-caption
                  <audio controls>
                    <source src={data.voicemail} />
                  </audio>
                )}
              </div>
            </div>
          </div>

          <div className={`chat-timestamp stamp-${data.direction}`}>
            {moment(data.sent_at * 1000).format('L [AT] LT')}
          </div>

          <AddNotesToCall
            ticket={ticket}
            callId={data.id}
            open={data.areNotesOpen}
            onToggleOpen={toggleOpenNotes}
          />
        </div>
      </div>
    </div>
  );
};
